export interface CfsMenuDto {
  items?: CfsMenuItemModel[];
  brand: CfsMenuBrandDto;
}

export interface CfsMenuBrandDto {
  id: number;
  name: string;
  shortName: string;
  logo: string;
  /**
   * Optional brand "call to action" text shown as the Kiosk menu description.
   * Populated by the backend once configured (CAP-6739); the UI falls back to the
   * default `cfs-menu.subtitle` translation while it is absent.
   */
  callToAction?: string;
}

export interface CfsMenuItemModel {
  action: CfsMenuAction;
  data: CfsMenuItemData; // todo: should be defined on the backend, now it is `data: Record<string, string>`
  features: string[]; // todo: should be defined on the backend (num list)
  title: string;
  icon: string;
  /** @deprecated */
  pageUrl: string;
}

export interface CfsMenuItemData {
  action: CfsMenuAction;
  locationId: number;
  cashRegisterId: number;
  widgetType: string;
  widgetId: number;
}

export enum CfsMenuAction {
  Redirect = "Redirect",
  MarketingApp = "MarketingApp",
  CheckIn = "CheckIn"
}
